function formatMoney(cents, format) {
    if (typeof cents === 'string') {
        cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            '$1' + thousands
        );
        var centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
        case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ');
            break;
        case 'amount_with_apostrophe_separator':
            value = formatWithDelimiters(cents, 2, "'");
            break;
    }

    return formatString.replace(placeholderRegex, value);
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    
    let parent = event.currentTarget.closest('details');
    if(!parent) {
      parent =  event.currentTarget.closest('.mega-menu');
    }
    
    event.currentTarget.setAttribute('aria-expanded', !parent.hasAttribute('open'));
    
    if(event.currentTarget.closest('.mega-menu')) {
      let link_url = event.currentTarget.getAttribute('data-link-url');
      if(link_url.length) {
        window.location.href = link_url;
      }
    }
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  if(elementToFocus) {
  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
    const sectionId = this.getAttribute('data-section-id');
    const priceEl = document.querySelector('#price-'+sectionId);
    const cartBtnPriceEl = document.querySelector('#submit_price-'+sectionId);

  
    if(priceEl) {
      let currentVariant =  null;
      
      if(document.querySelector('.product__info-wrapper variant-radios')) {
      currentVariant = document.querySelector('.product__info-wrapper variant-radios').currentVariant;
      } else if(document.querySelector('.product__info-wrapper variant-selects')) {
        currentVariant =   document.querySelector('.product__info-wrapper variant-selects').currentVariant;
      }

      if(currentVariant == null) {
        const product_dataEl = document.querySelector('#product_data_'+sectionId);
        if(product_dataEl) {
       currentVariant = JSON.parse(product_dataEl.textContent);
        }
      }
        
        if(currentVariant) {
          const product_price_itemEl = priceEl.querySelector('.price-item.price-item--regular');
          if(product_price_itemEl) {
            let currentVariant_price = currentVariant.price;
            let qtyVal = this.input.value * 1;

            if(typeof metadata == 'object') {
              Object.keys(metadata).forEach(key => {
                if (key == currentVariant.id) {
              for(let x=0;x <  metadata[key].length;x++) {
                const el = metadata[key][x];
                const min_range = el.range.split('-')[0] * 1;
                const max_range = el.range.split('-')[1] * 1;
      
                if(qtyVal >= min_range && qtyVal <= max_range ) {
                    currentVariant_price = el.price * 100;
                  break;
                }
              }  
            }
              });
            }

            if(currentVariant.compare_at_price) {
               const is_price__sale = priceEl.querySelector('.price__sale');
              if(is_price__sale) {
                 const old_priceEl = is_price__sale.querySelector('.price-item.price-item--regular');
                 const new_priceEl = is_price__sale.querySelector('.price-item.price-item--sale');

                if(old_priceEl) {
                  old_priceEl.innerHTML = formatMoney((currentVariant.compare_at_price * qtyVal), window.moneyFormat);
                }
                if(new_priceEl) {
                  new_priceEl.innerHTML = formatMoney((currentVariant_price * qtyVal), window.moneyFormat);
                }
              }
            } else {
              product_price_itemEl.innerHTML = formatMoney((currentVariant_price * qtyVal), window.moneyFormat);
            }

            if(cartBtnPriceEl) {
              cartBtnPriceEl.innerHTML = formatMoney((currentVariant_price * qtyVal), window.moneyFormat);
            }
          }
        }
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.localization-selector):not(.sort-list-option)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');

        const activeSearchForm = document.querySelector('.header-predictive-search-wrapper.active_form');
        if(activeSearchForm) {
          activeSearchForm.classList.remove('active_form');
          document.querySelector('predictive-search').closeResults(true);
        }
        
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {

      const activeSearchForm = document.querySelector('.header-predictive-search-wrapper.active_form');
      if(activeSearchForm) {
        activeSearchForm.classList.remove('active_form');
        document.querySelector('predictive-search').closeResults(true);
      }
      
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {  
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');
   
     document.body.classList.add('active-header-sticky');

    setTimeout(() => {

      const activeSearchForm = document.querySelector('.header-predictive-search-wrapper.active_form');
        if(activeSearchForm) {
          activeSearchForm.classList.remove('active_form');
          document.querySelector('predictive-search').closeResults(true);
        }
      
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
   
    if(!this.header.classList.contains('shopify-section-header-sticky')) {
      document.body.classList.remove('active-header-sticky');
    }
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    this.vertical_autoplay = this.slider.dataset.enable_vertical_slider;

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    // this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderItemsToShow = Array.from(this.sliderItems);
    if (this.sliderItemsToShow.length < 2) return;
   
   
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

        if(this.sliderItemsToShow[1].offsetLeft == 0 && this.sliderItemsToShow[1].classList.contains('thumbnail-list_item--variant')) {
      let sliderItemsToShow1 = null;
      for(let i=1; i < this.sliderItemsToShow.length;i++ ) {
          let sliderItemsToShowElem = this.sliderItemsToShow[i];
        if(!sliderItemsToShowElem.classList.contains('thumbnail-list_item--variant')) {
          sliderItemsToShow1 = sliderItemsToShowElem;
          break;
        }
      }
      if(sliderItemsToShow1 != null) {
         this.sliderItemOffset = sliderItemsToShow1.offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      }
    }
   
    
  if(this.sliderItemsToShow[0].classList.contains('desk-image-container') || this.sliderItemsToShow[0].classList.contains('thumbnail-desk-image-container') ) {
     this.sliderItemOffset = this.sliderItemsToShow[2].offsetLeft - this.sliderItemsToShow[1].offsetLeft;
  }
    
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {

    
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

   
    if(this.vertical_autoplay == 'true') {
    
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop;
        this.currentPage = Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1;
    }

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    let lastSlide = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if(this.slider.classList.contains('thumbnail-list')) {
      if(lastSlide.classList.contains('thumbnail-list_item--variant')) {
        const slidesArrwithout_variantImages = this.querySelectorAll('[id^="Slide-"]:not(.thumbnail-list_item--variant)');
        lastSlide = slidesArrwithout_variantImages[slidesArrwithout_variantImages.length - 1];
      }
    }

    if (this.isSlideVisible(lastSlide)) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {

      if(this.slider.classList.contains('thumbnail-list-left') ) {


      if( this.sliderItemsToShow[1]) {
      if(window.innerWidth >= 990) {

          this.sliderItemOffset = this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop;
        
      const lastVisibleSlide = this.slider.offsetHeight + this.slider.scrollTop - offset;
    return (element.offsetTop + element.clientHeight) <= lastVisibleSlide && element.offsetTop >= this.slider.offsetTop;
        
      } else {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
      }
    }
    } else {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;

     if(this.slider.classList.contains('thumbnail-list-left')) {
      if(window.innerWidth >= 990) {
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollTop + (step * this.sliderItemOffset) : this.slider.scrollTop - (step * this.sliderItemOffset);
    
    this.slider.scrollTo({
      top: this.slideScrollPosition
    });
        
      } else {
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
      }
    } else {
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);

    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
    }
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    
    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

     this.vertical_autoplay = this.slider.dataset.enable_vertical_slider;

    if(this.vertical_autoplay == 'true') {
      this.slider.style.height = this.sliderItemsToShow[0].offsetHeight + 'px';

    const _this = this;
    window.addEventListener("resize", debounce(function(e) {
        _this.slider.style.height = _this.sliderItemsToShow[0].offsetHeight + 'px';
     },50));
    }
    
 
    
    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });

    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
  
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
  
    if(this.vertical_autoplay == 'true') {
       const slideVerticalScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollTop + this.slider.querySelector('.slideshow__slide').clientHeight;

      if(slideVerticalScrollPosition == 0) {
        this.slider.style.scrollBehavior = 'auto';
      }
      this.slider.scrollTo({
      top: slideVerticalScrollPosition
    });
      if(slideVerticalScrollPosition == 0) {
        this.slider.style.scrollBehavior = 'smooth';
      }
      
    } else  {
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);


// Capisco builder start
const capiscoSubmitBtn = document.getElementById('capiscoSubmitButton');
const capiscoBtnTxt = document.querySelector('#capiscoSubmitButton .product-form__cart-submit-text');
    const priceWrapper = document.querySelector('.capisco-price .capisco-price-regular');
    const upsels = document.querySelectorAll('.upsell-input');
const optionaLInput = document.querySelectorAll('.gas-add-input');
const optFgInput = document.querySelectorAll('.footring-add');
let capiscoVariant = null;
let capiscoArr = [];
let currentVariantSku = '';

class CapiscoSelect extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onChairChange);   

    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.cartBtn = document.getElementById('capiscoSubmitButton');  

    this.cartBtn.addEventListener('click', e => {
      e.preventDefault();


      this.cartBtn.setAttribute('aria-disabled', true);
      this.cartBtn.classList.add('loading');
      const btn_overlay = this.cartBtn.querySelector('.loading-overlay__spinner');
      
      if(btn_overlay) {
         btn_overlay.classList.remove('hidden');
      }
      
      const request = JSON.parse(JSON.stringify(capiscoArr));

      
      const cartData = request.map(r => ({ 
        id: r.id, 
        quantity: r.quantity, 
        properties: r.properties
      }));


      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      const formData = {};
      formData.items =  cartData;
      if (this.cart) {
        formData.sections =  this.cart.getSectionsToRender().map((section) => section.id);
        formData.sections_url = window.location.pathname;
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = JSON.stringify(formData);
      
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {      

          if (response.status) {
            this.cartBtn.setAttribute('aria-disabled', true);
            this.cartBtn.querySelector('span').classList.add('hidden');
            this.error = true;
            if(btn_overlay) {
            btn_overlay.classList.add('hidden');
          }
        this.handleErrorMessage(response.description);
            
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          

          const upsell__modal = this.closest('.upsell__modal');
          if(upsell__modal) {
            upsell__modal.classList.remove('is-open');
          }
          
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {

          this.cartBtn.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.cartBtn.removeAttribute('aria-disabled');
          
          if(btn_overlay) {
            btn_overlay.classList.add('hidden');
          }
        
        });
      
 
    });
    
  }
  handleErrorMessage(errorMessage = false) {
    if (this.hideErrors) return;

    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }


  onChairChange() {
    this.getCurrentVariant();
    if (capiscoVariant) {
      this.hideUpselvariants(capiscoVariant);
      this.getPriceTotal();
      this.formArray();
      this.imageRender();
    }
  }

  getCurrentVariant() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    capiscoVariant = urlParams.get('variant');

    if(capiscoVariant) {

      const btnPriceEl = capiscoSubmitBtn.querySelector('.product-form__cart-submit-price');
      
      
      capiscoBtnTxt.innerHTML = 'Add to cart';
      capiscoSubmitBtn.disabled = false;

        if(btnPriceEl) {
         btnPriceEl.classList.remove('hide');  
      }
      

        if(btnPriceEl) {
         btnPriceEl.classList.remove('hide');  
      }
      
    }
    return capiscoVariant;
  }
  hideUpselvariants(variant) {
    //upsels.forEach((upsell) => upsell.checked = false);
    let selectedColor = '';
    const baseColors = document.getElementsByName('Base Color');
    baseColors.forEach(elem =>{
      if (elem.checked) {
        selectedColor = elem.value;
      }
    })
    upsels.forEach((upsell) => {
      if (upsell.dataset.option == selectedColor) {
        upsell.removeAttribute('disabled');
        upsell.classList.remove('hide');
      } else {
        upsell.setAttribute('disabled', 'disabled');
        upsell.classList.add('hide');  
      }
    })
  }
  getPriceTotal() {
    const variants = JSON.parse(this.querySelector('[type="application/json"]').textContent);
    let quantity = document.querySelector('.chair_variants .quantity__input').value;
    let currentVariantPrice = null;
    let currentVariantSku = '';

    const btnPriceEl = capiscoSubmitBtn.querySelector('.product-form__cart-submit-price');
    
    variants.forEach(variant => {
      if (variant.id == +capiscoVariant) {
        currentVariantPrice = variant.price;
        currentVariantSku = variant.sku;
      }
    })
    let totalPrice = currentVariantPrice;
      
      upsels.forEach((upsell)=>{
        if (upsell.checked) {
          totalPrice = totalPrice + Number(upsell.dataset.price);
        }
      })


      if (quantity > 1) {
        totalPrice = totalPrice * quantity;
      }


      priceWrapper.innerHTML = formatMoney(totalPrice, window.moneyFormat);

     const stickyVariantPriceEl = document.querySelector('.sticky-variant-price');
          if(stickyVariantPriceEl) {
        stickyVariantPriceEl.innerHTML = formatMoney(totalPrice, window.moneyFormat);
        priceWrapper.setAttribute('data-price',totalPrice);
      }

      if(btnPriceEl) {
     btnPriceEl.innerHTML = formatMoney(totalPrice, window.moneyFormat);
      btnPriceEl.classList.remove('hide');
    }
    
}
  formArray() {
    let quantity = document.querySelector('.chair_variants .quantity__input').value;
    let optionaLift = null;
    let optonalFootring = null;
    capiscoArr = [];
      
      optionaLInput.forEach((input) => {
        if (input.checked) {
        optionaLift = input.value;
        capiscoArr.push({
          id: optionaLift,
          quantity: quantity,
          properties: {
              '_capisco_builder': 'capisco_builder',
                '_type': 'optional_gas_lift'
          }
        });
        } else {
          optionaLift = null;
      } 
      });

      optFgInput.forEach((input) => {
        if (input.checked) {
          optonalFootring = input.value;
        capiscoArr.push({
          id: optonalFootring,
          quantity: quantity,
          properties: {
              '_capisco_builder': 'capisco_builder',
                '_type': 'optional_footring'
          }
        }); 
        } else {
          optonalFootring = null;
      } 
      });    
      
      if (capiscoVariant) {
        capiscoArr.push({
          id: capiscoVariant,
          quantity: quantity,
          properties: {
              '_capisco_builder': 'capisco_builder',
              '_type': 'chair'
          }
        });
        };

    return capiscoArr;
      } 
      
imageRender() {
      let glift = false;
      let footring = false;
      let liftColor,footringColor,image_alt = '';
      let sliderEnable = false;

let variantFeatureImage = document.querySelector('.chair-feature-media');
      let currentVariantFImage = '';

          var camelize = function camelize(str) {
          return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
      }
      
      const variants = JSON.parse(this.querySelector('[type="application/json"]').textContent);
      variants.forEach(variant => {
        if (variant.id == +capiscoVariant) {
          currentVariantSku = camelize(variant.sku);
      currentVariantFImage = variant.featured_image.id;
      }
      })

      upsels.forEach((upsell)=>{
        if (upsell.checked) {
          if (upsell.dataset.type == 'gas-lift') {
            glift = true;
            liftColor = upsell.dataset.lcolor;
          }
          if (upsell.dataset.type == 'footring') {
            footring = true;
            footringColor = upsell.dataset.fcolor;
          }

          if (glift && !footring) {
            image_alt = `upsell_${currentVariantSku}_${liftColor}`
          } else if (!glift && footring) {
            //testing product with footring
            image_alt = `upsell_${currentVariantSku}_def_${footringColor}`
          } else if (glift && footring) {
            image_alt = `upsell_${currentVariantSku}_${liftColor}_${footringColor}`
          }
        } else {
          return;
        }
      })


      const allUpsellMediia = document.querySelectorAll('.upsell-media');
      const featureVarIm = document.querySelector('.is-active');
      if (image_alt != '') {

      let upsellClass = `upsell-images-${image_alt}`;
      let currentUpsellMedia = document.querySelector(`[data-upsellid="${upsellClass}"]`);
      // let upsellImage = document.querySelector(`.${upsellClass} div`);
  

          allUpsellMediia.forEach(elem => {
            if (elem.dataset.upsellid == upsellClass) {
              elem.classList.remove('hide');
              elem.classList.add('showVariant');
            } else {
              elem.classList.add('hide');
              elem.classList.remove('showVariant');
            }
          })
          
          if(currentUpsellMedia) {
            featureVarIm.classList.add('hide');
          } else {
            featureVarIm.classList.remove('hide');
          }

      } else {
        featureVarIm.classList.remove('hide');
          allUpsellMediia.forEach((el) => {

      if (!el.classList.contains('hide')) {
            el.classList.add('hide');
        }
if (el.classList.contains('showVariant')) {
            el.classList.remove('showVariant');
          }
        })

    }
  }

}
customElements.define('capisco-builder', CapiscoSelect);
// Capisco builder end



class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);

    this.updateOptions();
    this.updateMasterId();    
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
  
    // this.toggleAddButton(true, '', false);
    // this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }


  updateOptions() {
    
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
        
    this.currentVariant = this.getVariantData().find((variant) => {
    
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });

  }

  updateMedia() {

    
    //capiscoBuilderCreate(this.currentVariant);
    
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    let productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);

    if(this.classList.contains('upsell-product-modal-variants')) {
      productForms = document.querySelectorAll(`#product-form-${this.dataset.product_id}`);
    }
    
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {

    const isUpsellModal = this.classList.contains('upsell-product-modal-variants');   
    
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    
    if(isUpsellModal) {
    const _this = this;
      
      fetch(`${this.dataset.url}.js`)      
    .then(response => response.json())
    .then(function (data) {    
      
      if(_this) {
       _this.toggleAddButton(!data.available, window.variantStrings.soldOut);
      }    
    })
      
    } else {
    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
   
        
        // prevent unnecessary ui changes from abandoned selections
        if(!this.currentVariant) {
          return;
        }
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
        const inventoryStockInfoSource = html.getElementById(`InventoryStockInfo-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryStockInfoDestination =document.getElementById(`InventoryStockInfo-${this.dataset.section}`);


        const stickyBuyButtonDestionation =  document.getElementById(`sticky-buy-button-${this.dataset.section}`);
        const stickyBuyButtonSource =  html.getElementById(`sticky-buy-button-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        if (stickyBuyButtonSource && stickyBuyButtonDestionation) {
              stickyBuyButtonDestionation.innerHTML = stickyBuyButtonSource.innerHTML;
          
            const is_capiscoBuilder = document.querySelector('capisco-builder');
            if(is_capiscoBuilder) {
          const stickyVariantPriceEl = document.querySelector('.sticky-variant-price');
          if(stickyVariantPriceEl) {
            const capisco_priceWrapper = document.querySelector('.capisco-price .capisco-price-regular');
            const capisco_price = capisco_priceWrapper.getAttribute('data-price');
            stickyVariantPriceEl.innerHTML = formatMoney(capisco_price, window.moneyFormat);
          }    
            }
        }
                const submit_priceDestination = document.getElementById(`submit_price-${this.dataset.section}`); 
        const submit_priceSource = html.getElementById(`submit_price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

      
         if (submit_priceSource && submit_priceDestination) {
           const is_capiscoBuilder = submit_priceDestination.closest('capisco-builder');
           if(!is_capiscoBuilder) {
             submit_priceDestination.innerHTML = submit_priceSource.innerHTML; 
           }
         } 
        
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }
         if (inventoryStockInfoSource && inventoryStockInfoDestination) inventoryStockInfoDestination.innerHTML = inventoryStockInfoSource.innerHTML;

        
        const price = document.getElementById(`price-${this.dataset.section}`);

        
        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);


         // Update variant specs
      var variantSpess = document.querySelectorAll('.top_variant_specifications');
      if (variantSpess.length > 0) {
        variantSpess.forEach(el => {

          el.classList.add('hide');
          if (this.currentVariant.id == +el.dataset.variant ) {
            el.classList.remove('hide');
          }
        })
      }
        

        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});
      });
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {


     const isUpsellModal = this.classList.contains('upsell-product-modal-variants');

     let productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if(isUpsellModal) {
       productForm = document.getElementById(`product-form-${this.dataset.product_id}`);
    } 
   
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    const addButtonPrice = productForm.querySelector('.product-form__cart-submit-price');
    
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;

      if(addButtonPrice) {
        addButtonPrice.classList.add('hide');
      }
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;

      if(addButtonPrice) {
        addButtonPrice.classList.remove('hide');
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);


        if(!button) {
      return false;
    }
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  } 

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);

    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
   
    const fieldsets = Array.from(this.querySelectorAll('.fieldset'));
    
    this.options = fieldsets.map((fieldset) => {     

       let option_selected_valueEl = fieldset.querySelector('.option_selected_value');

     
    if(fieldset.querySelector("input:checked")) {
         const checkedValue = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      
      if(option_selected_valueEl) {
        option_selected_valueEl.innerHTML = checkedValue;
      }
      
      return checkedValue;
    }
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          // if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          //   this.remove();
          // }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


class UpsellProduct extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {

    const _this = this;
    this.upsell__btn = this.querySelector('.upsell__btn');
    this.productID = this.getAttribute('data-product-id');

    if(this.upsell__btn) {
       this.upsell__btn.addEventListener('click',this.onButtonClick.bind(this));
    }

      this.formModal = document.querySelector('#upsell__modal_'+this.productID);
    
    if(this.formModal) {
      this.formModalOverlay =  this.formModal.querySelector('.upsell__modal__overlay');
      this.formModalCloseBtn =  this.formModal.querySelector('.upsell__modal__close');

      if(this.formModalOverlay) {
        this.formModalOverlay.addEventListener('click', this.closeFormModal.bind(this));
      }
       if(this.formModalCloseBtn) {
        this.formModalCloseBtn.addEventListener('click', this.closeFormModal.bind(this));
      }
    }   

 
  }
   onButtonClick(event) {

      event.preventDefault();
         this.formModal = document.querySelector('#upsell__modal_'+this.productID);
        if( this.formModal) {
          this.formModal.classList.add('is-open');
        }
   }
  closeFormModal(event) {
    this.formModal = document.querySelector('#upsell__modal_'+this.productID);
      if(this.formModal) {
          this.formModal.classList.remove('is-open');
        }
  }
}

customElements.define('upsell-product', UpsellProduct);



class FeaturedSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const _this = this;
    this.columns_mobile = this.getAttribute('data-columns_mobile');
    this.columns_desktop = this.getAttribute('data-columns_desktop');
    this.sliderEl = this.querySelector('.featured-slider-wrapper');
    this.slidesArr = this.sliderEl.querySelectorAll('.featured-slide');
    this.autoplayStr = this.getAttribute('data-autoplay');
    this.autoplayVal = this.autoplayStr === "true";
    this.autoplaySpeed = this.dataset.speed * 1000;

    this.slider_btn_prev = this.querySelector('.slider-button--prev');
    this.slider_btn_next = this.querySelector('.slider-button--next');

    if(this.slidesArr.length > 1) {
    if(this.closest('.featured_articles_slider_section') ) {
  
    let initSlider = false;
    function responseSectionSlider() {
  
        var windowWidth = window.innerWidth;
        if(windowWidth <= 749) {
          if(initSlider) {
            initSlider = false;
            $(_this.sliderEl).slick('unslick');          
          }
        } else {
          if(initSlider == false) {
            initSlider = true;

             _this.options = {
                slidesToShow: _this.columns_desktop,
                slidesToScroll: 1,
                infinite: true,
                arrows: true,
                prevArrow: _this.slider_btn_prev,
                nextArrow: _this.slider_btn_next
              };
              $(_this.sliderEl).slick(_this.options);  
             
          }
        }
    }
    responseSectionSlider();
     window.addEventListener("resize", debounce(function(e) {
       responseSectionSlider();
   },100));

    } else {
      this.options = {
    slidesToShow: _this.columns_desktop,
    slidesToScroll: 1,
    infinite: true,
    autoplay: _this.autoplayVal,
    autoplaySpeed: _this.autoplaySpeed,
    arrows: true,
    prevArrow: _this.slider_btn_prev,
    nextArrow: _this.slider_btn_next,
    responsive: [
      {
            breakpoint: 767,
            settings: {
              slidesToShow: _this.columns_mobile
            }
        }
    ]
    };
      $(_this.sliderEl).slick(_this.options);
    }
    }
  }

}

customElements.define('featured-slider', FeaturedSlider);


class BuilderUpsellProductModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {

    const _this = this;
    this.formModal = document.querySelector('.submit_upsell__modal');
    if(this.formModal) {
      this.formModalOverlay =  this.formModal.querySelector('.upsell__modal__overlay');
      this.formModalCloseBtn =  this.formModal.querySelector('.upsell__modal__close');
      this.btn_continue = this.formModal.querySelector('.btn-continue'); 

      if(this.formModalOverlay) {
        this.formModalOverlay.addEventListener('click', this.closeFormModal.bind(this));
      }
       if(this.btn_continue) {
        this.btn_continue.addEventListener('click', this.closeFormModal.bind(this));
      }
       if(this.formModalCloseBtn) {
        this.formModalCloseBtn.addEventListener('click', this.closeFormModal.bind(this));
      }
    }    
  }
    openFormModal(event) {
      
        if(this.formModal) {
          this.formModal.classList.add('is-open');
        }
   }
  closeFormModal(event) {
      if(this.formModal) {
          this.formModal.classList.remove('is-open');
      }
  }
}

customElements.define('submit-upsell-modal', BuilderUpsellProductModal);


class Brands extends HTMLElement {
  constructor() {
    super();

    const $sectionSliderContainer = $(this).find('.swiper-container--top-brands');
    const sectionId = this.getAttribute('data-section-id');
    
    if($sectionSliderContainer.length) {
    this.swiperTopBrands = new Swiper(".swiper-container--top-brands", {
    slidesPerView: 6,
    slidesPerGroup: 6,
    autoplay: {
    delay: 2000
    },
    loop: true,
    navigation: {
    nextEl: ".swiper-button-next--top-brands-"+sectionId,
    prevEl: ".swiper-button-prev--top-brands-"+sectionId
    },
    breakpoints: {
    767: {
    slidesPerView: 2,
    slidesPerGroup: 2
    },
    1479: {
    slidesPerView: 4,
    slidesPerGroup: 4
    }
    }
    });
    }
}
 
  connectedCallback() {
    
  }
}
customElements.define('brands-slider', Brands);

class Featured_media_slider extends HTMLElement {
  constructor() {
    super();

    const $sectionSliderContainer = $(this).find('.media-blocks--slider');
    const sectionId = this.getAttribute('data-section-id');
    const slidesPerRow = this.getAttribute('data-slides_per_row') * 1 || 4;
    const infinity_loopFlag = !!this.getAttribute('data-infinite_loop') || false;
    const sliderAutoplay = !!this.getAttribute('data-autoplay') || false; 
    const showDots = !!this.getAttribute('data-show-dots') || false; 

    const sliderSpeed =  this.getAttribute('data-speed') * 1000 || 3000; 
    let tabletSlidesPerRow = 3;
    let small_tabletSlidesPerRow = 2;
    if(slidesPerRow < 3) {
      tabletSlidesPerRow = slidesPerRow;
    }
    if(slidesPerRow == 1)     {
        small_tabletSlidesPerRow = 1;
      }
   
    if($sectionSliderContainer.length) {
      $sectionSliderContainer.slick({
        infinite: infinity_loopFlag,
        slidesToShow: slidesPerRow,
        slidesToScroll: 1,
        dots: showDots,
        arrows: true,
        autoplay: sliderAutoplay,
        autoplaySpeed: sliderSpeed,
        nextArrow: '<div class="slick-button-next" aria-label="Next">' + window.assets.icon_right + '</div>',
        prevArrow: '<div class="slick-button-prev" aria-label="Previous">' + window.assets.icon_left + '</div>',
        responsive: [
           {
            breakpoint: 1200,
            settings: {
              slidesToShow: tabletSlidesPerRow
            }
          },
          {
            breakpoint: 990,
            settings: {
              slidesToShow: small_tabletSlidesPerRow
            }
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 1
            }
          }
        ]
  });
    }

}
 
  connectedCallback() {
    
  }
}

customElements.define('custom-media-blocks--slider', Featured_media_slider);
class TabsAnimationSlider extends HTMLElement {
  constructor() {
    super();
     this.pausedSlider = false;
     this.animationSpeed = this.getAttribute('data-animation_speed') * 1000;
      this.animationSpeed += 500;
   
    
     this.slidesArr = this.querySelectorAll('.tabs_animation_slider_nav__item');

     function RecurringTimer(callback, delay) {
    var timerId, start, remaining = delay;

    this.stop = function () {
          window.clearTimeout(timerId);
       };
    this.pause = function() {
        window.clearTimeout(timerId);
        remaining -= new Date() - start;
    };

    var resume = function() {
        start = new Date();
        timerId = window.setTimeout(function() {
            remaining = delay;
            resume();
            callback();
        }, remaining);
    };
    
    this.resume = resume;

    this.resume();
}
     this.RecurringTimer = RecurringTimer;

  }
  connectedCallback() {
    this.activeIndex = 0;    
    if(this.slidesArr.length > 1) {
      this.activateAnimate();
     for(const slide_nav of this.slidesArr) {
       slide_nav.addEventListener('click',this.changeActiveSlide.bind(this));
     }
    }
        
  }
  activetedSlide(activeSlide) {
    const _this = this; 
    const block_id = activeSlide.getAttribute('data-block-id'); 
    const tabs_animation_slide_El = document.querySelector('#'+block_id);
    
      if(tabs_animation_slide_El)     {
        tabs_animation_slide_El.classList.add('active');
      }
     activeSlide.classList.add('active'); 

    if(window.innerWidth <= 767) {
      const activeNavItem_offsetLeft = activeSlide.offsetLeft;
      const tabs_animation_slider_navParentEl = activeSlide.closest('.tabs_animation_slider_nav');
      if(tabs_animation_slider_navParentEl) {

        tabs_animation_slider_navParentEl.scrollTo({
        top: 0,
        left: (activeNavItem_offsetLeft - 15),
        behavior: 'smooth'
      });
      }
    }
  }
 
  activateAnimate() {
    const _this = this;
    this.timer =  _this.RecurringTimer(function() { 

        const prevActiveSlide = _this.querySelector('.tabs_animation_slider_nav__item.active');
        if(prevActiveSlide) {
          const prev_block_id = prevActiveSlide.getAttribute('data-block-id'); 
          const prev_tabs_animation_slideEl = document.querySelector('#'+prev_block_id);
               
          prevActiveSlide.classList.remove('active');
            _this.activeIndex = _this.activeIndex + 1;
          if(prev_tabs_animation_slideEl) {
            prev_tabs_animation_slideEl.classList.remove('active');
          }   

          let activeSlide = _this.slidesArr[_this.activeIndex];
          if(!activeSlide) {
            _this.activeIndex = 0;
            activeSlide = _this.slidesArr[_this.activeIndex];
          }
            
          if(activeSlide) {
            _this.activetedSlide(activeSlide);       
          }        
        }             
    }, _this.animationSpeed);
  }

  stopAnimate() {
    const _this = this;
    this.pausedSlider = true;
     this.stop();
    _this.classList.add('stopAnimate');
  }
  
  getSlideIndex(node) {
  var children = node.parentNode.childNodes;
    var num = 0;
    for (var i=0; i<children.length; i++) {
         if (children[i]==node) return num;
         if (children[i].nodeType==1) num++;
    }
    return -1;
  }
  
  changeActiveSlide(e) {
    e.preventDefault();
    const _this = this;
    let el = e.target;
    
    this.stopAnimate();
    if(!el.classList.contains('tabs_animation_slider_nav__item')) {
      el = el.closest('.tabs_animation_slider_nav__item');
    }
    const prevActiveSlide = this.querySelector('.tabs_animation_slider_nav__item.active');
    if(prevActiveSlide) {
         const prev_block_id = prevActiveSlide.getAttribute('data-block-id'); 
        const prev_tabs_animation_slide_El = document.querySelector('#'+prev_block_id);
           
         prevActiveSlide.classList.remove('active');
       if(prev_tabs_animation_slide_El) {
          prev_tabs_animation_slide_El.classList.remove('active');
        }
      _this.activetedSlide(el);
      _this.activeIndex = _this.getSlideIndex(el);   
      }    
   
  }
}

customElements.define('tabs-animation-slider', TabsAnimationSlider);



class StickyBuyButton extends HTMLElement {
  constructor() {
    super();

    const _this = this;
    this.scopeFrom = document.querySelector(this.getAttribute('data-scopeFrom'));
    this.scopeTo = document.querySelector('footer.footer');

    this.formEl = document.querySelector(this.getAttribute('form'));
    this.submitBtn = this.querySelector('.sticky-submit-button');
    this.headerHeight = document.querySelector('.site-header').offsetHeight || 0;
    this.topBarHeight = document.querySelector('.announcement-bar-section').offsetHeight || 0;
         
    if (!this.scopeFrom || !this.scopeTo) {
      return;
    }
      document.addEventListener('click', function(e){
      var el = e.target;
      
      if(el.classList.contains('sticky-submit-button') || el.closest('.sticky-submit-button')) {
        if(!el.classList.contains('sticky-submit-button')) {
          el = el.closest('.sticky-submit-button');
        }
           e.preventDefault();
       
        if(el.classList.contains('sticky_scroll_btn')) {
          const parentSectionEl = el.closest("section");
          if(parentSectionEl) {
             const productInfoEl = parentSectionEl.querySelector('product-info');
            if(productInfoEl) {
              productInfoEl.scrollIntoView({
                behavior: 'smooth'
              });            
            }
          }
         
        } else {
          _this.formEl.dispatchEvent(new Event('submit', { bubbles: true }));
        }
    }
    });
    
    const intersectionObserver = new IntersectionObserver(this.handleIntersection.bind(this));
    intersectionObserver.observe(this.scopeFrom);
    intersectionObserver.observe(this.scopeTo);
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
     
      if (entry.target === this.scopeFrom) {      
        this.scopeFromPassed = entry.boundingClientRect.bottom < 0;
      }
      if (entry.target === this.scopeTo) {
        this.scopeToReached = entry.isIntersecting;
      }
    });
    
    if (this.scopeFromPassed && !this.scopeToReached) {
        this.classList.remove('animate-out');
        this.classList.add('animate-in');
    }
    else {
      if(this.classList.contains('animate-in')) {
        this.classList.remove('animate-in');
        this.classList.add('animate-out');
      }
    }
  }
}
customElements.define('sticky-buy-button', StickyBuyButton);

class VerticalAnimationSlider extends HTMLElement {
   constructor() {
     super();
      this.pausedSlider = false;
      this.animationSpeed = this.getAttribute('data-animation_speed') * 1000;
       this.animationSpeed += 500;
      this.pause_play_btn = this.querySelector('.pause-play-btn');
     
      this.slidesArr = this.querySelectorAll('.slide');
 
      function RecurringTimer(callback, delay) {
     var timerId, start, remaining = delay;
 
     this.stop = function () {
           window.clearTimeout(timerId);
        };
     this.pause = function() {
         window.clearTimeout(timerId);
         remaining -= new Date() - start;
     };
 
     var resume = function() {
         start = new Date();
         timerId = window.setTimeout(function() {
             remaining = delay;
             resume();
             callback();
         }, remaining);
     };
     
     this.resume = resume;
 
     this.resume();
 }
      this.RecurringTimer = RecurringTimer;
 
   }
   connectedCallback() {
     this.activeIndex = 0;    
     if(this.slidesArr.length > 1) {
       const firstSlide  = this.slidesArr[0];
       if(firstSlide) {
           const first_slideContent = firstSlide.querySelector('.slide_content');
           if(first_slideContent) {
              first_slideContent.classList.add('calculating');
                 const first_slideContentHeight  = first_slideContent.offsetHeight;
              first_slideContent.classList.remove('calculating');
             first_slideContent.style.maxHeight = first_slideContentHeight+'px';
           }
       }
       this.activateAnimate();
      for(const slide of this.slidesArr) {
        slide.addEventListener('click',this.changeActiveSlide.bind(this));
      }
     }
         
    this.pause_play_btn.addEventListener('click',this.togglePlaySlider.bind(this));  
   }
   activetedSlide(activeSlide) {
     console.log('activetedSlide');
     const _this = this;
     let slideContentHeight = 0;
     const bg_image = activeSlide.getAttribute('data-bg-image');
     
     const block_id = activeSlide.getAttribute('data-block-id'); 
     const vertical_animation_slider_bgEl = document.querySelector('#'+block_id);
     
     
     const slideContent = activeSlide.querySelector('.slide_content');
     if(slideContent) {
       slideContent.classList.add('calculating');
       slideContentHeight = slideContent.offsetHeight;
       slideContent.classList.remove('calculating');
       slideContent.style.maxHeight = slideContentHeight+'px';
     }
     
       if(vertical_animation_slider_bgEl)     {
         vertical_animation_slider_bgEl.classList.add('active');
       }
      activeSlide.classList.add('active'); 
   
   }
  
   activateAnimate() {
     const _this = this;
     this.timer =  _this.RecurringTimer(function() { 
 
         const prevActiveSlide = _this.querySelector('.slide.active');
         if(prevActiveSlide) {
           const prevActiveSlideContent = prevActiveSlide.querySelector('.slide_content');
           const prev_block_id = prevActiveSlide.getAttribute('data-block-id'); 
           const prev_vertical_animation_slider_bgEl = document.querySelector('#'+prev_block_id);
                
           prevActiveSlide.classList.remove('active');
           if(prevActiveSlideContent) {
           prevActiveSlideContent.removeAttribute('style');
           }           
             _this.activeIndex = _this.activeIndex + 1;
           if(prev_vertical_animation_slider_bgEl) {
             prev_vertical_animation_slider_bgEl.classList.remove('active');
           }   
 
           let activeSlide = _this.slidesArr[_this.activeIndex];
           if(!activeSlide) {
             _this.activeIndex = 0;
             activeSlide = _this.slidesArr[_this.activeIndex];
           }
             
           if(activeSlide) {
             _this.activetedSlide(activeSlide);       
           }        
         }             
     }, _this.animationSpeed);
   }
 
   stopAnimate() {
     const _this = this;
     this.pausedSlider = true;
      this.stop();
     _this.classList.add('stopAnimate');
   }
   
   pauseAnimate() {
     this.pausedSlider = !this.pausedSlider;
     if(this.pausedSlider) {
        this.classList.add('paused');
         this.pause();
     } else {
        this.classList.remove('paused');
      
       if( this.classList.contains('stopAnimate')) {
          this.classList.remove('stopAnimate');
         this.activateAnimate();
       } else {
           this.resume();
       }
     }
   }
   
   getSlideIndex(node) {
   var children = node.parentNode.childNodes;
     var num = 0;
     for (var i=0; i<children.length; i++) {
          if (children[i]==node) return num;
          if (children[i].nodeType==1) num++;
     }
     return -1;
   }
   
   changeActiveSlide(e) {
     e.preventDefault();
     const _this = this;
     let el = e.target;
     
     this.stopAnimate();
     if(!el.classList.contains('slide')) {
       el = el.closest('.slide');
     }
     const prevActiveSlide = this.querySelector('.slide.active');
     if(prevActiveSlide) {
          const prevActiveSlideContent = prevActiveSlide.querySelector('.slide_content');
          const prev_block_id = prevActiveSlide.getAttribute('data-block-id'); 
         const prev_vertical_animation_slider_bgEl = document.querySelector('#'+prev_block_id);
            
          prevActiveSlide.classList.remove('active');
         if(prevActiveSlideContent) {
           prevActiveSlideContent.removeAttribute('style');
         } 
        if(prev_vertical_animation_slider_bgEl) {
               prev_vertical_animation_slider_bgEl.classList.remove('active');
         }
       _this.activetedSlide(el);
       _this.activeIndex = _this.getSlideIndex(el);   
       }    
    
   }
   togglePlaySlider(e) {
     e.preventDefault();
     this.pauseAnimate();
   }
 }
customElements.define('vertical-animation-slider', VerticalAnimationSlider);